const DownloadEndpoints = {
  reportDownloadSuccess: {
    method: 'POST',
    url: () => `/users/user-activity`,
  },
} as const;

export default DownloadEndpoints;
